"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var withKey_1 = __importDefault(require("./hoc/withKey"));
var useStyles_1 = __importDefault(require("./useStyles"));
var useCheckIsHeaderCell_1 = __importDefault(require("./hooks/useCheckIsHeaderCell"));
var useCheckIsSubheaderCell_1 = __importDefault(require("./hooks/useCheckIsSubheaderCell"));
var HeaderLabel_1 = __importDefault(require("./HeaderLabel"));
var Grid_1 = __importDefault(require("../../Grid"));
var Cell = function (props) {
    var style = props.style, cellKey = props.cellKey, columnIndex = props.columnIndex, _a = props.rowIndex, rowIndex = _a === void 0 ? -1 : _a, _b = props.fixedRowCount, fixedRowCount = _b === void 0 ? 0 : _b, _c = props.columns, columns = _c === void 0 ? [] : _c, _d = props.data, data = _d === void 0 ? [] : _d, getCellStyle = props.getCellStyle;
    var classes = (0, useStyles_1.default)();
    var item = data[rowIndex - fixedRowCount];
    var column = columns[columnIndex || 0];
    var headerLabel = column.headerLabel, HeaderComponent = column.headerComponent, subheaderLabel = column.subheaderLabel, SubheaderComponent = column.subheaderComponent, id = column.id, BodyComponent = column.bodyComponent;
    var isHeaderCell = (0, useCheckIsHeaderCell_1.default)(rowIndex, fixedRowCount);
    var isSubheaderCell = (0, useCheckIsSubheaderCell_1.default)(rowIndex, fixedRowCount);
    var componentProps = (0, react_1.useMemo)(function () { return ({
        columnIndex: columnIndex,
        rowIndex: rowIndex,
        column: column,
        data: item
    }); }, [
        columnIndex,
        rowIndex,
        column,
        item
    ]);
    return (react_1.default.createElement("div", { key: cellKey, style: (getCellStyle && getCellStyle({ rowIndex: rowIndex, columnIndex: columnIndex, style: style })) || style, className: classes.cell },
        react_1.default.createElement(Grid_1.default, { container: true, alignItems: "center", classes: { root: classes.containerRoot }, spacing: 0 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                isHeaderCell && ((!!headerLabel && react_1.default.createElement(HeaderLabel_1.default, null,
                    react_1.default.createElement("b", null, headerLabel)))
                    || (!!HeaderComponent && react_1.default.createElement(HeaderComponent, __assign({}, componentProps)))),
                isSubheaderCell && ((!!subheaderLabel && react_1.default.createElement(HeaderLabel_1.default, null, subheaderLabel))
                    || (!!SubheaderComponent && react_1.default.createElement(SubheaderComponent, __assign({}, componentProps)))),
                !(isHeaderCell || isSubheaderCell) && ((!!BodyComponent && react_1.default.createElement(BodyComponent, __assign({}, componentProps)))
                    || (!!id && !!item[id] && react_1.default.createElement(HeaderLabel_1.default, null, item[id])))))));
};
exports.default = (0, withKey_1.default)(Cell);
